import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlineShieldExclamation, HiX, HiOutlineCheckCircle, HiOutlineExclamationCircle } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const SecurityModal = ({ isOpen, onClose, onProceed }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleProceed = () => {
    if (onProceed) onProceed();
    else navigate("/repayloan");
    onClose();
  };

  const listVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.3 + i * 0.1, duration: 0.4 }
    })
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
        <style>
          {`
            .security-modal-scroll::-webkit-scrollbar {
              width: 6px;
            }
            .security-modal-scroll::-webkit-scrollbar-track {
              background: rgba(0,0,0,0.02);
              border-radius: 10px;
            }
            .security-modal-scroll::-webkit-scrollbar-thumb {
              background: rgba(0,0,0,0.15);
              border-radius: 10px;
            }
            .security-modal-scroll::-webkit-scrollbar-thumb:hover {
              background: rgba(0,0,0,0.25);
            }
            .security-modal-scroll {
              scrollbar-width: thin;
              scrollbar-color: rgba(0,0,0,0.15) rgba(0,0,0,0.02);
            }
          `}
        </style>
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.75)",
          backdropFilter: "blur(10px)",
          zIndex: 99999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px"
        }}>
          <motion.div
            className="security-modal-scroll"
            initial={{ opacity: 0, scale: 0.95, y: 30 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 30 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            style={{
              background: "#ffffff",
              borderRadius: "24px",
              width: "100%",
              maxWidth: "600px",
              maxHeight: "90vh",
              overflowY: "auto",
              boxShadow: "0 40px 80px rgba(0, 0, 0, 0.4)",
              position: "relative",
              textAlign: "left",
              display: "flex",
              flexDirection: "column"
            }}
          >
            {/* Header */}
            <div style={{
              background: "linear-gradient(135deg, #133a47 0%, #2889a6 100%)",
              color: "white",
              padding: "25px",
              borderTopLeftRadius: "24px",
              borderTopRightRadius: "24px",
              display: "flex",
              alignItems: "center",
              gap: "15px",
              position: "sticky",
              top: 0,
              zIndex: 10,
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
            }}>
              <motion.div 
                animate={{ scale: [1, 1.1, 1], opacity: [0.8, 1, 0.8] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                style={{
                  background: "rgba(255,255,255,0.15)",
                  padding: "10px",
                  borderRadius: "50%",
                  display: "flex",
                  boxShadow: "0 0 20px rgba(255,255,255,0.2)"
                }}
              >
                <HiOutlineShieldExclamation size={36} color="#fff" />
              </motion.div>
              <div>
                <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "800", letterSpacing: "0.5px" }}>Security Alert</h2>
                <h3 style={{ margin: "2px 0 0 0", fontSize: "14px", fontWeight: "500", opacity: 0.85, letterSpacing: "0.5px" }}>सुरक्षा चेतावनी</h3>
              </div>
              <button 
                onClick={onClose}
                style={{
                  marginLeft: "auto",
                  background: "rgba(255,255,255,0.1)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
                onMouseOver={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.25)"}
                onMouseOut={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
              >
                <HiX size={22} />
              </button>
            </div>

            {/* Content */}
            <div style={{ padding: "30px", color: "#333", fontSize: "15px", lineHeight: "1.6" }}>
              
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} style={{ marginBottom: "25px" }}>
                <p style={{ margin: "0 0 8px 0", fontWeight: "700", color: "#1f2937", fontSize: "16px" }}>
                  Fraudsters are sending fake payment requests via WhatsApp, SMS, and social media, impersonating actoloan.in employees. Stay alert:
                </p>
                <p style={{ margin: 0, color: "#6b7280", fontSize: "14px" }}>
                  धोखेबाज़ WhatsApp, SMS और सोशल मीडिया के माध्यम से नकली भुगतान अनुरोध भेज रहे हैं, जो actoloan.in के कर्मचारियों के रूप में पहचान बना रहे हैं। सतर्क रहें:
                </p>
              </motion.div>

              <ul style={{ padding: 0, margin: "0 0 25px 0", listStyle: "none", display: "flex", flexDirection: "column", gap: "16px" }}>
                {[
                  { en: "Do not click unknown links or reply to suspicious messages.", hi: "अज्ञात लिंक पर क्लिक न करें या संदिग्ध संदेशों का जवाब न दें।" },
                  { en: "Verify email IDs and domains before engaging.", hi: "संलग्न होने से पहले ईमेल ID और डोमेन सत्यापित करें।" },
                  { en: "Be cautious of calls or messages claiming to be from us.", hi: "हमारे होने का दावा करने वाले कॉल या संदेशों से सावधान रहें।" }
                ].map((item, index) => (
                  <motion.li 
                    custom={index}
                    initial="hidden"
                    animate="visible"
                    variants={listVariants}
                    key={index} 
                    style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}
                  >
                    <HiOutlineExclamationCircle size={22} color="#2889a6" style={{ flexShrink: 0, marginTop: "2px" }} />
                    <div>
                      <div style={{ fontWeight: "700", color: "#374151" }}>{item.en}</div>
                      <div style={{ color: "#6b7280", marginTop: "4px", fontSize: "14px" }}>{item.hi}</div>
                    </div>
                  </motion.li>
                ))}
              </ul>

              <motion.div 
                initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.6 }}
                style={{ background: "linear-gradient(to right, #fff1f2, #ffffff)", padding: "18px", borderRadius: "12px", borderLeft: "4px solid #f43f5e", marginBottom: "25px", boxShadow: "0 4px 15px rgba(244, 63, 94, 0.05)" }}
              >
                <p style={{ margin: "0 0 6px 0", fontWeight: "800", color: "#be123c", fontSize: "15px" }}>
                  actoloan.in is not responsible for losses from payments to unverified persons or links.
                </p>
                <p style={{ margin: 0, color: "#9f1239", fontSize: "14px", fontWeight: "500" }}>
                  actoloan.in अप्रमाणित व्यक्तियों या लिंक को भुगतान से होने वाले नुकसान के लिए जिम्मेदार नहीं है।
                </p>
              </motion.div>

              <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }} style={{ marginBottom: "25px" }}>
                <h4 style={{ margin: "0 0 12px 0", fontSize: "17px", color: "#047857", display: "flex", alignItems: "center", gap: "8px", fontWeight: "800" }}>
                  <HiOutlineCheckCircle size={24} /> Safe Payment / सुरक्षित भुगतान
                </h4>
                <div style={{ background: "linear-gradient(to right, #ecfdf5, #f0fdf4)", padding: "18px", borderRadius: "12px", border: "1px solid #a7f3d0", boxShadow: "0 4px 15px rgba(5, 150, 105, 0.05)" }}>
                  <p style={{ margin: "0 0 6px 0", fontWeight: "700", color: "#065f46" }}>
                    Pay only through our official website actoloan.in or authorized link.
                  </p>
                  <p style={{ margin: "0 0 12px 0", color: "#047857", fontSize: "14px" }}>
                    भुगतान केवल हमारी आधिकारिक वेबसाइट actoloan.in या अधिकृत लिंक से करें।
                  </p>
                  <p style={{ margin: "0 0 6px 0", fontWeight: "700", color: "#065f46" }}>
                    Do not trust any unknown number/link.
                  </p>
                  <p style={{ margin: 0, color: "#047857", fontSize: "14px" }}>
                    किसी अज्ञात नंबर/लिंक पर भरोसा न करें।
                  </p>
                </div>
              </motion.div>

              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1 }} style={{ textAlign: "right", color: "#4b5563", fontStyle: "italic", fontWeight: "700", fontSize: "15px" }}>
                - Team Actoloan<br/>
                <span style={{ color: "#2889a6", fontWeight: "800" }}>actoloan.in</span>
              </motion.div>

            </div>

            {/* Footer */}
            <div style={{ padding: "20px 30px", borderTop: "1px solid #f3f4f6", display: "flex", justifyContent: "flex-end", gap: "12px", background: "#f9fafb", borderBottomLeftRadius: "24px", borderBottomRightRadius: "24px" }}>
              <button 
                onClick={onClose}
                style={{
                  padding: "14px 24px",
                  borderRadius: "12px",
                  border: "1px solid #d1d5db",
                  background: "white",
                  color: "#4b5563",
                  fontWeight: "700",
                  cursor: "pointer",
                  transition: "all 0.2s",
                  fontSize: "15px"
                }}
                onMouseOver={(e) => e.currentTarget.style.background = "#f3f4f6"}
                onMouseOut={(e) => e.currentTarget.style.background = "white"}
              >
                Cancel
              </button>
              <button 
                onClick={handleProceed}
                style={{
                  padding: "14px 28px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #2889a6 0%, #1a647a 100%)",
                  color: "white",
                  fontWeight: "700",
                  cursor: "pointer",
                  boxShadow: "0 8px 20px rgba(40,137,166,0.25)",
                  transition: "all 0.3s",
                  fontSize: "15px"
                }}
                onMouseOver={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 12px 25px rgba(40,137,166,0.35)"; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 20px rgba(40,137,166,0.25)"; }}
              >
                Proceed to Repay / आगे बढ़ें
              </button>
            </div>

          </motion.div>
        </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SecurityModal;
